jQuery(document).ready(function($) {

    $('.entry-content > p > .responsive-embed').parent().addClass('video-embedded');

    /**
     * Append share text to social share buttons.
     */
    const shareText = `
        <p class="social-share-notice">
        Sharing our content may mean you also share your personal data with the chosen social media platform. Find out more
        <a href="https://www.thepsci.eu/about/privacy-policy/"> here</a>.
        </p>`
    $('.social-wrap').append(shareText);
		
		// set twitter feed height
		let 
		twit_column = $('.twitter-column'),
		twit_column_parent_height = twit_column.parent().height(),
		twit_column_height = ( $(window).width() < 1024 ) ? '450' : twit_column_parent_height - 20,
		twit_column_width = twit_column.width(),
		twit_timeline = $('.twitter-timeline');
		
		twit_timeline.attr('data-height', twit_column_height);
		twit_timeline.attr('data-width', twit_column_width);
});
